import Quill from "quill";

const BlockEmbed = Quill.import('blots/block/embed');

class NeteaseBlot extends BlockEmbed {
    static blotName: string;
    static tagName: string;
    static className: string;
    static create(value: any) {
        const node = super.create();
        if (value) {
            node.setAttribute('frameborder', 'no');
            node.setAttribute('border', '0');
            node.setAttribute('marginwidth', '0');
            node.setAttribute('marginheight', '0');
            node.setAttribute('width', 330);
            node.setAttribute('height', 86);
            node.setAttribute('src', value);
            node.setAttribute('sandbox', 'allow-same-origin allow-scripts');
        }
        return node;
    }

    static value(node: { getAttribute: (arg0: string) => any }) {
        const v = node.getAttribute('src');
        return v;
    }
}
NeteaseBlot.blotName = 'netease';
NeteaseBlot.tagName = 'iframe';
NeteaseBlot.className = 'ql-netease';

Quill.register(NeteaseBlot, true);
